import gql from "graphql-tag";

export const IS_USER_EXISTS = gql`
  query IsUserExists($email: String!) {
    isUserExists(email: $email)
  }
`;

export const SEARCH_OMS_USERS = gql`
  query SearchOmsUsers($input: SearchUsersInput!) {
    omsUsers(input: $input) {
      id
      firstName
      middleName
      lastName
      email
      expired
      assignment {
        id: assignmentId
        expired
        position {
          id
          name
        }
        org {
          id
          name
        }
      }
      assignedRoles {
        userRoleTypeId
        orgScope {
          id
          name
        }
      }
      phoneNumbers
    }
  }
`;

export const USER_INFO_FRAGMENT = gql`
  fragment userProfileFragment on UserProfile {
    id
    firstName
    middleName
    lastName
    email
    expired
    individualId
    assignment {
      id: assignmentId
      expired
      position {
        id
        name
      }
      org {
        id
        name
      }
    }
  }
`;

export const SEARCH_SECURITY_USERS = gql`
  ${USER_INFO_FRAGMENT}
  query SearchSecurityUsers($input: SearchUsersInput!) {
    securityUsers(input: $input) {
      ...userProfileFragment
      assignedRoles {
        key
        userRoleTypeId
        orgScope {
          id
          name
        }
      }
    }
  }
`;

export const GET_USER_PROFILE = gql`
  ${USER_INFO_FRAGMENT}
  query GetUserProfile($userAccountId: ID!) {
    userProfile(userAccountId: $userAccountId) {
      ...userProfileFragment
      assignedRoles {
        key
        userRoleTypeId
        orgScope {
          id
          name
        }
      }
    }
  }
`;

export const GET_USER_ASSIGNMENT = gql`
  query GetUserAssignment($assignmentId: ID!) {
    userAssignment(assignmentId: $assignmentId) {
      id: assignmentId
      expired
      position {
        id
        name
      }
      org {
        id
        name
      }
    }
  }
`;

export const CREATE_USER_PROFILE = gql`
  mutation CreateUserProfile($user: UserInfoInput!, $roles: [AssignedRoleInput]) {
    createUserProfile(user: $user, roles: $roles)
  }
`;

export const UPDATE_USER = gql`
  ${USER_INFO_FRAGMENT}
  mutation UpdateUserInfo($userAccountId: ID!, $user: UserInfoInput!) {
    updateUser(userAccountId: $userAccountId, user: $user) {
      ...userProfileFragment
    }
  }
`;

export const ADD_USER_ROLES = gql`
  mutation AddUserRoles($userAccountId: ID!, $roles: [AssignedRoleInput]!) {
    addUserRoles(userAccountId: $userAccountId, roles: $roles) {
      key
      userRoleTypeId
      orgScope {
        id
        name
      }
    }
  }
`;

export const REMOVE_USER_ROLES = gql`
  mutation RemoveUserRoles($userAccountId: ID!, $roles: [AssignedRoleInput]!) {
    removeUserRoles(userAccountId: $userAccountId, roles: $roles) {
      key
      userRoleTypeId
      orgScope {
        id
        name
      }
    }
  }
`;

export const GET_USER_MEMOS = gql`
  query GetUserMemos($userAccountId: ID!) {
    userMemos(userAccountId: $userAccountId) {
      id: memoId
      memoTxt
      createUser
      createUserInfo {
        firstName
        lastName
      }
      createTimestamp
    }
  }
`;

export const CREATE_USER_MEMO = gql`
  mutation CreateUserMemo($userAccountId: ID!, $content: String!) {
    createUserMemo(userAccountId: $userAccountId, content: $content) {
      id: memoId
      memoTxt
      createUser
      createTimestamp
    }
  }
`;
